import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let selectedOption = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_option',
    viewPath: props.viewPath,
  })
  let isEmergency = useDataValue({
    context: 'appointment_overlay',
    path: 'is_emergency',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return data.map(item => ({
      ...item,
      isSelected: item.id === selectedOption,
      isDisabled: item.id === 'new' && isEmergency,
    }))
  }, [data, selectedOption, isEmergency])
}
